import { Action } from '@ngrx/store';
import { ICategories } from '../models/categoriesresponse.model';

export enum ECategoriesActions {
  GetCategories = '[Categories] Get Categories',
  GetCategoriesSuccess = '[Categories] Get Categories Success'
}

export class GetCategories implements Action 
{
  public readonly type = ECategoriesActions.GetCategories;
  constructor(public payload:string) 
  {
      
  }
}

export class GetCategoriesSuccess implements Action {
  public readonly type = ECategoriesActions.GetCategoriesSuccess;
  constructor(public payload: ICategories) {
    
  }
}

export type CategoriesActions =
  | GetCategories
  | GetCategoriesSuccess;